//This ensures regular hrefs to non-angular pages work as intended
//make sure to use ui-sref if you want angular routing
//the z is for alphabetical loading order issues :(
export default function uiRouterFix($rootElement) {
  $rootElement.off('click');
}

uiRouterFix.$inject = ['$rootElement'];
